import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { MOBILE_MENU_FEATURE, MobileMenuState, StateWithMobileMenu } from '../mobile-menu-state';

export const getMainFeatureState: MemoizedSelector<StateWithMobileMenu, MobileMenuState> =
  createFeatureSelector<MobileMenuState>(MOBILE_MENU_FEATURE);
